<template>
  <div class="content">
    <loading
      name="lp"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <base-header class="pb-6">
      <div class="row align-items-center py-0"></div>
    </base-header>

    <div class="container-fluid mt--6">
      <div class="card mb-4">
        <div class="card-header">
          <div class="row mb-4">
            <div class="col-lg-3 col-sm-12">
              <base-button outline type="primary" block @click="onBack()">
                <span class="btn-inner--icon">
                  <i class="ni sign-left"></i>
                </span>
                Back to main page</base-button
              >
            </div>
          </div>
        </div>
        <div class="row card-body" v-for="cls in classes" :key="cls.id">
          <div class="col-lg-4">
            <card>
              <div class="row">
                <div class="col-lg-12">
                  <h4>{{ cls.code }}.{{ cls.coursetitle }}</h4>
                </div>
                <div class="col-lg-12">
                  <h5>Installments</h5>
                  <div class="row mb-2">
                    <div class="col-lg-6 col-6 font-size-14">Pay till</div>
                    <div class="col-lg-6 col-6 font-size-14">Amount</div>
                  </div>
                  <div
                    class="row mb-1"
                    v-for="item in inst.filter((c) => c.classid === cls.id)"
                    :key="item.id"
                  >
                    <div class="col-lg-6 col-6 font-size-12">
                      {{ item.paydate }}
                    </div>
                    <div class="col-lg-6 col-6 font-size-12">
                      {{ "₼ " + item.amount }}
                    </div>
                  </div>
                </div>
              </div>
            </card>
          </div>
          <div class="col-lg-8">
            <card>
              <div class="row">
                <div class="col-lg-12">
                  <h4>{{ cls.code }}.{{ cls.coursetitle }}</h4>
                </div>
                <div class="col-lg-12"><h5>Payments</h5></div>
              </div>
              <div class="row mb-2">
                <div class="col-4 font-size-14">Pay date</div>
                <div class="col-4 font-size-14">Amount</div>
                <div class="col-4 font-size-14">Pay type name</div>
              </div>
              <div
                class="row mb-1"
                v-for="item in tran.filter((c) => c.classid === cls.id)"
                :key="item.id"
              >
                <div class="col-4 font-size-12">{{ item.paydate }}</div>
                <div class="col-4 font-size-12">
                  {{ "₼ " + item.amountazn }}
                </div>
                <div class="col-4 font-size-12">
                  {{ item.paytypename }}
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { GetClassesByStudent } from "../../../services/classes";
import {
  GetInstallmentsByStudent,
  GetTranByStudent,
} from "../../../services/payments";
export default {
  components: {
    Loading,
  },
  data() {
    return {
      classes: [],
      tran: [],
      inst: [],
      isLoading: false,
    };
  },
  methods: {
    onBack() {
      this.$router.push({ name: "StudentMain" }).catch((e) => {});
    },
  },
  mounted() {
    GetClassesByStudent(0, this.$store.state.user.id).then((response) => {
      if (response.data.result) {
        this.classes = response.data.result.filter((c) => c.payertype === 1);

        GetTranByStudent(this.$store.state.user.id).then((response) => {
          if (response.data.result) {
            this.tran = response.data.result;
          } else {
            this.tran = [];
          }
        });

        GetInstallmentsByStudent(this.$store.state.user.id).then((response) => {
          console.log(this.$store.state.user.id);
          if (response.data.result) {
            this.inst = response.data.result;
          } else {
            this.inst = [];
          }
        });
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.font-size-14 {
  font-size: 14px;
}
.font-size-12 {
  font-size: 12px;
}
</style>